import { FC } from "react";
import { useProfileBalance } from "../../context/ProfileContext/ProfileBalanceContext/ProfileBalanceContext";
import "../balance/balance.css";
import { formatToMexicanPesos } from "../utils/format";
import { Tooltip } from "@mui/material";
import { useNavigate } from 'react-router-dom';
interface IProps {}

export const ProfileBalance: FC<IProps> = (props) => {
    const navigate = useNavigate();
    const { balance, loading } = useProfileBalance();

 const handleNavigate = () => {
    navigate('transferencias/retiros'); // Reemplaza con la ruta a la que quieres redirigir
  };

  return (
    <Tooltip title="Saldo total" placement="bottom">
      <div className="balance-chip" onClick={handleNavigate}>
        <span className="balance-text" >
          {" "}
          Saldo:{" "}
          {formatToMexicanPesos(balance?.totalCost || 0)}
        </span>
      </div>
    </Tooltip>
  );
};
